import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from '@@/bits/vue'
import { OzListRowSeparator } from '@@/library/v4/components/OzWallListRow.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { ConfirmationDialogLayoutVariant, useGlobalConfirmationDialogStore } from '@@/pinia/global_confirmation_dialog'
import { storeToRefs } from 'pinia'
import { nextTick, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalConfirmationDialog',
  setup(__props) {

const OzOverlay = defineAsyncComponent(() => import('@@/library/v4/components/OzOverlay.vue'))
const OzConfirmationDialogBox = defineAsyncComponent(
  () => import('@@/library/v4/components/OzConfirmationDialogBox.vue'),
)
const OzDrawerConfirmationDialog = defineAsyncComponent(
  () => import('@@/library/v4/components/OzDrawerConfirmationDialog.vue'),
)
const OzLargeConfirmationDialog = defineAsyncComponent(
  () => import('@@/library/v4/components/OzLargeConfirmationDialog.vue'),
)
const OzWallListRow = defineAsyncComponent(() => import('@@/library/v4/components/OzWallListRow.vue'))

const darkModeStore = useDarkModeStore()
const globalConfirmationDialogStore = useGlobalConfirmationDialogStore()

const { isOpen, confirmationDialogData } = storeToRefs(globalConfirmationDialogStore)
const { isDarkMode } = storeToRefs(darkModeStore)

const { confirm, cancel, discard } = globalConfirmationDialogStore

const dialogBox = ref<InstanceType<typeof OzConfirmationDialogBox>>()

watch(
  isOpen,
  (newIsOpen: boolean): void => {
    if (newIsOpen) nextTick(() => dialogBox.value?.focus())
  },
  { immediate: true },
)

return { __sfc: true,OzOverlay, OzConfirmationDialogBox, OzDrawerConfirmationDialog, OzLargeConfirmationDialog, OzWallListRow, darkModeStore, globalConfirmationDialogStore, isOpen, confirmationDialogData, isDarkMode, confirm, cancel, discard, dialogBox, OzListRowSeparator, ConfirmationDialogLayoutVariant }
}

})